module.exports = __webpack_public_path__ + "static/media/American_Economic_Association_Logo.6eeff339.png";